(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cilo-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cilo-kabelvaelger"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cilo-kabelvaelger')) {
    class CiloKabelvaelger extends HTMLElement {
      connectedCallback() {
        this.sep = ' – ';
        this.param = this.dataset.param;
        this.from = this.querySelector('[data-kv-from]');
        this.to = this.querySelector('[data-kv-to]');
        this.submit = this.querySelector('[data-kv-submit]');
        this.status = this.querySelector('[data-kv-status]');
        this.reset = this.querySelector('[data-kv-reset]');
        this.querySelector('form').addEventListener('submit', (e) => {
          e.preventDefault();
          this.go();
        });
        this.from.addEventListener('change', () => this.fillTo());
        this.to.addEventListener('change', () => this.update());
        this.reset.addEventListener('click', (e) => {
          e.preventDefault();
          this.go(true);
        });
        this.load();
      }

      async load() {
        let el = this.querySelector('[data-kv-data]');
        if (!el && this.dataset.pageMode === 'true' && this.dataset.sourceUrl) {
          try {
            const res = await fetch(this.dataset.sourceUrl + '?section_id=cilo-kabelvaelger');
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            el = doc.querySelector('[data-kv-data]');
          } catch (e) {}
        }
        if (!el) {
          this.hidden = true;
          return;
        }
        try {
          this.values = JSON.parse(el.textContent).filter((v) => v.count > 0 || v.active);
        } catch (e) {
          this.values = [];
        }
        if (!this.values.length) {
          this.hidden = true;
          return;
        }
        this.pairs = this.values.map((v) => {
          const ends = v.value.split(this.sep);
          return { value: v.value, a: ends[0], b: ends[1] || ends[0], count: v.count, active: v.active };
        });
        const ends = [...new Set(this.pairs.flatMap((p) => [p.a, p.b]))].sort((x, y) => x.localeCompare(y, 'da'));
        this.fillSelect(this.from, ends);
        this.from.disabled = false;

        const active = this.pairs.find((p) => p.active);
        if (active) {
          this.from.value = active.a;
          this.fillTo();
          this.to.value = active.b;
          this.reset.hidden = false;
        }
        this.update();
      }

      fillSelect(select, items, counts) {
        const first = select.options[0];
        select.replaceChildren(first);
        items.forEach((item) => {
          const o = document.createElement('option');
          o.value = item;
          o.textContent = counts && counts[item] ? `${item} (${counts[item]})` : item;
          select.append(o);
        });
      }

      fillTo() {
        const f = this.from.value;
        if (!f) {
          this.fillSelect(this.to, []);
          this.to.disabled = true;
          this.update();
          return;
        }
        const counts = {};
        this.pairs.forEach((p) => {
          if (p.a === f) counts[p.b] = (counts[p.b] || 0) + p.count;
          else if (p.b === f) counts[p.a] = (counts[p.a] || 0) + p.count;
        });
        const items = Object.keys(counts).sort((x, y) => x.localeCompare(y, 'da'));
        this.fillSelect(this.to, items, counts);
        this.to.disabled = false;
        if (items.length === 1) this.to.value = items[0];
        this.update();
      }

      selected() {
        const f = this.from.value;
        const t = this.to.value;
        if (!f || !t) return null;
        const key = [f, t].sort((x, y) => (x < y ? -1 : x > y ? 1 : 0)).join(this.sep);
        return this.pairs.find((p) => p.value === key) || null;
      }

      update() {
        const s = this.selected();
        this.submit.disabled = !s;
        this.status.textContent = s ? `${s.count} ${s.count === 1 ? 'kabel' : 'kabler'}` : '';
      }

      go(clear = false) {
        const s = this.selected();
        if (!s && !clear) return;
        const base = this.dataset.pageMode === 'true' ? this.dataset.sourceUrl : window.location.pathname;
        const params = new URLSearchParams(this.dataset.pageMode === 'true' ? '' : window.location.search);
        params.delete(this.param);
        params.delete('page');
        if (!clear) params.append(this.param, s.value);
        const qs = params.toString();
        window.location.href = base + (qs ? '?' + qs : '');
      }
    }
    customElements.define('cilo-kabelvaelger', CiloKabelvaelger);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
